import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4d52e0a2"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "aside-logo flex-column-auto position-relative",
  id: "kt_aside_logo"
}
const _hoisted_2 = {
  class: "d-flex flex-row justify-content-start align-items-center flex-fill cursor-pointer py-3 rotate",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-attach": "parent",
  "data-kt-menu-placement": "bottom-end",
  "data-kt-menu-flip": "bottom"
}
const _hoisted_3 = { class: "logo-default" }
const _hoisted_4 = { class: "d-flex flex-row justify-content-start align-items-center" }
const _hoisted_5 = ["src"]
const _hoisted_6 = ["src"]
const _hoisted_7 = {
  key: 3,
  class: "ms-2 rotate-180"
}
const _hoisted_8 = { class: "svg-icon svg-icon-1" }
const _hoisted_9 = { class: "logo-minimize" }
const _hoisted_10 = ["src"]
const _hoisted_11 = ["title", "onClick"]
const _hoisted_12 = ["alt", "src"]
const _hoisted_13 = { class: "svg-icon rotate-180" }
const _hoisted_14 = { class: "aside-menu overflow-hidden flex-column-fluid" }
const _hoisted_15 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_KTMenu = _resolveComponent("KTMenu")!

  return (_openBlock(), _createElementBlock("div", {
    id: "kt_aside",
    class: _normalizeClass(["aside aside-hoverable", [
      _ctx.asideTheme === 'light' && 'aside-light',
      _ctx.asideTheme === 'dark' && 'aside-dark',
    ]]),
    "data-kt-drawer": "true",
    "data-kt-drawer-name": "aside",
    "data-kt-drawer-activate": "{default: true, lg: false}",
    "data-kt-drawer-overlay": "true",
    "data-kt-drawer-width": "{default:'200px', '300px': '250px'}",
    "data-kt-drawer-direction": "start",
    "data-kt-drawer-toggle": "#kt_aside_mobile_toggle",
    onMouseleave: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleMouseLeave && _ctx.handleMouseLeave(...args)))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            (_ctx.asideTheme === 'dark')
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  alt: "MagicBean",
                  src: _ctx.darkLogo,
                  height: "32"
                }, null, 8, _hoisted_5))
              : _createCommentVNode("", true),
            (_ctx.asideTheme === 'light')
              ? (_openBlock(), _createElementBlock("img", {
                  key: 1,
                  alt: "MagicBean",
                  src: _ctx.lightLogo,
                  height: "32"
                }, null, 8, _hoisted_6))
              : _createCommentVNode("", true),
            (_ctx.sysVersion == 'dev' || _ctx.sysVersion == 'staging')
              ? (_openBlock(), _createElementBlock("span", {
                  key: 2,
                  class: _normalizeClass(["tag", [
                _ctx.sysVersion == 'dev' && 'dev',
                _ctx.sysVersion == 'staging' && 'staging',
              ]])
                }, _toDisplayString(_ctx.sysVersion), 3))
              : _createCommentVNode("", true),
            (_ctx.workspaceApps.length > 0)
              ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
                  _createElementVNode("span", _hoisted_8, [
                    _createVNode(_component_inline_svg, {
                      src: 
                    require('../../assets/media/icons/duotune/arrows/arr072.svg')
                  
                    }, null, 8, ["src"])
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("img", {
            src: require('../../assets/media/logos/logo-mini.svg'),
            class: "h-30px",
            alt: "MagicBean"
          }, null, 8, _hoisted_10)
        ])
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["menu menu-sub menu-sub-dropdown menu-column fw-bold fs-6", _ctx.workspaceApps.length > 0 && 'pb-4']),
        "data-kt-menu": "true"
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.workspaceApps, (app) => {
          return (_openBlock(), _createElementBlock("div", {
            key: app.app_id,
            class: "menu-item"
          }, [
            _createElementVNode("div", {
              title: app.name,
              class: "menu-link px-4 py-4",
              onClick: ($event: any) => (_ctx.onAppClick(app.link))
            }, [
              _createElementVNode("img", {
                alt: app.name,
                src: app.app_logo,
                height: "32"
              }, null, 8, _hoisted_12)
            ], 8, _hoisted_11)
          ]))
        }), 128))
      ], 2),
      _createElementVNode("div", {
        id: "kt_aside_toggle",
        class: "btn btn-icon px-0 btn-active-color-primary aside-toggle btn-sm btn-color-muted h-30px w-30px position-absolute top-50 start-100 translate-middle rotate bg-white border border-secondary shadow-sm",
        "data-kt-toggle": "true",
        "data-kt-toggle-state": "active",
        "data-kt-toggle-target": "body",
        "data-kt-toggle-name": "aside-minimize",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.hideOtherDropdowns && _ctx.hideOtherDropdowns(...args)))
      }, [
        _createElementVNode("span", _hoisted_13, [
          _createVNode(_component_inline_svg, {
            src: require('../../assets/media/icons/duotune/arrows/arr060.svg')
          }, null, 8, ["src"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createVNode(_component_KTMenu)
    ]),
    _createElementVNode("a", {
      ref: "hiddenLink",
      href: _ctx.currentAppUrl,
      target: "_blank",
      style: {"display":"none"}
    }, null, 8, _hoisted_15)
  ], 34))
}